export default "__VITE_ASSET__cZAEpWEo__"